const zh = {
	shortMessage: '短信',
	recordList: '记录列表',
	phoneNumber: '手机号',
	moduleId: '模板id',
	parameter: '参数',
	sendTime: '发送时间',
	WeChat: '微信',
	content: '内容',
	messageRecord: '消息记录',
};

export default zh;
